"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setGlobalEventBus = exports.getGlobalEventBus = exports.initGlobalEventBus = exports.MBEventBus = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
// TODO where move this?
class MBEventBus extends web_ui_framework_1.EventBus {
}
exports.MBEventBus = MBEventBus;
let globalEventBus = undefined;
const initGlobalEventBus = () => {
    globalEventBus = new web_ui_framework_1.EventBus();
};
exports.initGlobalEventBus = initGlobalEventBus;
const getGlobalEventBus = () => {
    return globalEventBus;
};
exports.getGlobalEventBus = getGlobalEventBus;
const setGlobalEventBus = (eventBus) => {
    if (eventBus) {
        globalEventBus = eventBus;
    }
};
exports.setGlobalEventBus = setGlobalEventBus;
//# sourceMappingURL=eventBusManager.js.map